import type { FC, ReactNode } from 'react'

import { Filter, Rocket, TrendingUp } from 'lucide-react'

import { Reveal } from '@/components/generals/reveal'
import { Section } from '@/components/generals/section'
import { SectionHeading } from '@/components/generals/section-heading'
import { processSteps } from '@/constants/content'

const icons = [Filter, Rocket, TrendingUp]

export const Process: FC = (): ReactNode => {
    return (
        <Section id='process'>
            <SectionHeading
                eyebrow='Process'
                segments={[
                    { text: 'Our simple 3-step process to' },
                    { text: 'skyrocket', serif: true },
                    { text: 'your business.' }
                ]}
                subtitle='From Google ads, to Meta ads, to TikTok ads, and even content creation, we’ve got you covered on everything front.'
            />

            <Reveal
                y={26}
                blur={10}
                delay={0.1}
                stagger={0.12}
                className='mt-14 grid w-full grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-8 lg:mt-20'
            >
                {processSteps.map((step, index) => {
                    const Icon = icons[index]

                    return (
                        <div
                            key={step.title}
                            className='group flex flex-col items-center gap-4 text-center'
                        >
                            <span className='relative flex size-14 items-center justify-center rounded-2xl bg-surface-1 text-[#8b5cf6] ring-1 ring-white/8 transition-all duration-500 ease-[cubic-bezier(0.44,0,0.56,1)] group-hover:-translate-y-1 group-hover:shadow-[0_16px_40px_-18px_rgba(139,92,246,0.9)] group-hover:ring-[#8b5cf6]/40'>
                                <Icon
                                    aria-hidden='true'
                                    className='size-6'
                                />
                            </span>

                            <h3 className='text-lg leading-none font-medium tracking-[-0.02em] text-white'>
                                {step.title}
                            </h3>

                            <p className='max-w-[34ch] text-[15px] leading-[1.55] tracking-[-0.01em] text-white/56'>
                                {step.body}
                            </p>
                        </div>
                    )
                })}
            </Reveal>
        </Section>
    )
}
